import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromActions from '../../@core/store/auth-state/auth.actions';
import { Router } from '@angular/router';
import { CreateUserRequest, LoginRequest } from './interfaces/http-requests';
import { HttpRequesterService } from '../../@core/services/http-requester.service';
import { ApiRoutes } from '../../@core/enum/api-routes.enum';
import { AppFullRoutes } from '../../@core/enum/appRoutes';
import { AuthState } from '../../@core/store/app/app.states';
import { LoginHttpResponse } from '../../@core/types/http-responses.type';
import { CreateUserHttpResponse } from '../../@core/types/base-http-response.type';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {
    constructor(private httpRequester: HttpRequesterService, private store: Store<AuthState>, private router: Router) { }

    public login(body: LoginRequest): Observable<LoginHttpResponse> {
        return this.httpRequester.post<LoginHttpResponse>(ApiRoutes.LOGIN, body);
    }

    public createUser(body: CreateUserRequest): Observable<CreateUserHttpResponse> {
        return this.httpRequester.post<CreateUserHttpResponse>(ApiRoutes.CREATE_USER, body);
    }

    public logout(redirectTo?: string) {
        this.store.dispatch(fromActions.LogoutCurrentUserAuthAction());
        this.router.navigateByUrl(redirectTo || AppFullRoutes.FULL_ROLE_SELECTOR);
    }
}
